import styled from 'styled-components';

export const EyeIconSeen = styled.div`
  color: ${({ seenStatus }) => (seenStatus ? '#87878c' : '#e4e4eb')};
  cursor: pointer;
`;

export const EyeIconChecked = styled.div`
  color: black;
  cursor: pointer;
`;
